import Moment from 'moment-timezone';
import qs from 'qs'

import config from 'config';
import settingStore from 'modules/cms/stores/setting';
import { LOADING, LOADED } from 'stores/BaseStore';
import alertStore from 'stores/alert'
import app from 'stores/app';
import HttpClient from 'utils/httpclient';

export default class BaseReportStore {
  /**
   * @property {endpointReport: string} - The report api endpoint
   *
   */

  constructor(attachToSelectedSite = true) {
    this.attachToSelectedSite = attachToSelectedSite
    this.entities = []
  }

  get entryPoint() {
    if (this.attachToSelectedSite) {
      return `site/${app.currentSiteID}/${this.endpointReport}`
    }

    return this.endpointReport
  }

  collection = {
    readyState: LOADED,
    data: null,
    get isLoading() {
      return this.readyState === LOADING
    },
  }

  resetCollection() {
    this.collection.readyState = LOADED
    this.collection.data = null
  }

  async loadPostContentTypes() {
    this.postContentTypes = await loadContents();
  }

  async fetchData({ startDate, endDate, groupby, sortby, metrics, filterby, timezone, detachedSite, comparison }) {
    try {
      timezone = timezone || app.timezone
      const params = {
        groupby, sortby, metrics, filterby,
        siteId: app.currentSiteID,
        startDate: Moment.tz(startDate.format('YYYY-MM-DD'), timezone).startOf('day').format(),
        endDate: Moment.tz(endDate.format('YYYY-MM-DD'), timezone).endOf('day').format(),
        comparison,
      }
      this.collection.readyState = LOADING;
      const { data } = await HttpClient.post(`${config.api}/reports/${detachedSite ? this.endpointReport : this.entryPoint}`, JSON.parse(JSON.stringify(params)))

      this.collection.data = data
      this.collection.readyState = LOADED
    } catch (e) {
      this.resetCollection()
      alertStore.error("Error", "Unable to get results")
    }
  }

  async drilldown({ startDate, endDate, filterby, size, isExport, fields, credential }) {
    try {
      const params = {
        credential,
        isExport,
        fields,
        size,
        filterby,
        siteId: app.currentSiteID,
        startDate: Moment.tz(startDate.format('YYYY-MM-DD'), app.timezone).startOf('day').format(),
        endDate: Moment.tz(endDate.format('YYYY-MM-DD'), app.timezone).endOf('day').format(),
      }
      const { data } = await HttpClient.post(`${config.api}/reports/drilldown/${app.currentSiteID}/${this.endpointReport}`, params)
      return data
    } catch (e) {
      alertStore.error("Error", "Unable to get results")
    }
  }

  attachEntity(store, { labelKey, valueKey, extra: extraKeys, filterValue, labelFn, params } = {}) {
    const entity = buildEntity(store, { labelKey, extraKeys, filterValue, labelFn, params, valueKey });
    this.entities.push(entity)
    return entity
  }
  resetEntities() {
    this.entities.forEach(entity => entity.reset())
  }
}

export function buildEntity(store, { labelKey = 'name', valueKey = "id", extraKeys = [], filterValue = 'value', labelFn, params = { report: true } }) {
  const entity = {
    objects: null,
    objectsMapping: {},
    get isLoading() {
      return store.isLoading
    },
    get fetchData() {
      return async (detachedSite = false) => {
        if (!this.objects) {
          if (detachedSite) {
            params.sites = (app.sites || await app.listSites()).filter(site => site.organization_id === app.site.organization_id).map(({ id }) => id)
          } else {
            params.sites = [app.currentSiteID]
          }

          await store.all(params)
          this.objects = store.collection.objects.length !== 0 && store.collection.objects.map(({ [valueKey]: value, [labelKey]: label, ...remains }) => {
            const item = {
              ...extraKeys.reduce((extra, key) => ({ ...extra, [key]: remains[key] }), {}),
              value,
              label,
            }
            item.getValue = () => item[filterValue]
            item.getLabel = (labelFn || (({ value, label }) => `[#${value}] - ${label}`)).bind(null, item)
            this.objectsMapping[value] = item
            return item
          }) || null;
        }
        return this.objects
      }
    },
    reset() {
      this.objects = null
      store.resetCollection()
    },
  }
  return entity
}

export async function loadContents() {
  return Object.keys(await settingStore.getThemeConfig('theme_settings.types'));
}
